import VueAppLayout from './app-layout.vue'

export const AppLayout = VueAppLayout

export * from './layouts.types'
export * from './templates'
